// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d3-3";
export var flatBottomCorners = "_d3-5";
export var productImage = "_d3-0";
export var quantityContainer = "_d3-2";
export var quantityHeader = "_d3-6";
export var tooltip = "_d3-1";
export var wrapAndEllipsesOverflow = "_d3-4";